import { Country, getCountryList } from 'api/countries/getCountriesList'
import { useDataApi } from 'api/useDataApi'
import { useCallback } from 'react'
import { FetchHookLifecycle, FetchHook } from './Fetch'

export const useFetchCountryList = (): FetchHook<Country[]> => {
  const { data, isError } = useDataApi({
    apiCall: useCallback(async () => {
      return await getCountryList()
    }, [])
  })

  if (data) return { type: FetchHookLifecycle.SUCCESS, data }
  if (isError)
    return {
      type: FetchHookLifecycle.ERROR,
      error: new Error('Failed to fetch countries')
    }
  return { type: FetchHookLifecycle.LOADING }
}
